// ════════════════════════════════════════════════════════════
//  SpriteManifest.js — the player portraits THE MARK prints
// ════════════════════════════════════════════════════════════
//  The vendored Mark.js imports { PLAYER_SPRITES } from "./SpriteManifest"
//  for the portrait on the card: player_f IS Lyraei, player_m IS Laostre
//  (Terror's rule — the same two the Sky Box walks in 3D).
//  Paths are the Pier's (app-unstable-pierre/src/SpriteManifest.js): on
//  terror-assets only the four walk directions exist, so front / idle /
//  default alias the walk-down frame there too. When the idle art is
//  uploaded, change the alias lines and nothing else.
// ════════════════════════════════════════════════════════════
const CDN = "https://terror-assets.pages.dev";
const g = (s) => ({
  [`player_${s}_down_a`]: `${CDN}/player_${s}_down_a.webp`,
  [`player_${s}_up_a`]: `${CDN}/player_${s}_up_a.webp`,
  [`player_${s}_left_a`]: `${CDN}/player_${s}_left_a.webp`,
  [`player_${s}_right_a`]: `${CDN}/player_${s}_right_a.webp`,
  [`player_${s}_front_a`]: `${CDN}/player_${s}_down_a.webp`,
  [`player_${s}_idle_a`]: `${CDN}/player_${s}_down_a.webp`,
  [`player_${s}_default`]: `${CDN}/player_${s}_down_a.webp`,
});
export const PLAYER_SPRITES = { ...g("f"), ...g("m") };
